import React, {Component} from "react"
import {connect} from 'react-redux';
import Layout from "../../../components/Layout"
import CreateFilters from '../../../components/FilterReports/create';

import "./index.scss"

import {schedule_get_all_filters} from "../../../store/actions/schedule";

import {
    Grid
} from "carbon-components-react";

//import {Undo16} from "@carbon/icons-react";

import leng from "../../../data";


class Create extends Component {
    state = {
        isOppened2: true,
        isOppened3: false,
        isOppenedSubmit: false,
        form: {
            skuisOpened: false,
            skuDetailsisOpenend: false,
            dateStart: "",
            dateEnd: "",
            sku: [],
            brand: [],
            category: [],
            hero: [],
            majorCategory: [],
            abcd: [],
            subCategory: [],
            plcLocal: [],
            chanel: [],
        }
    };

    componentDidMount() {
      //  this.props.fetchData();
    }

    getFilters(data) {
        //console.log(data);
        //alert('A');
        let sku = [];
        let brand = [];
        let category = [];
        let hero = [];
        let majorCategory = [];
        let abcd = [];
        let subCategory = [];
        let plcLocal = [];

        data.forEach(dados => {
            sku.push({id: dados['sku'], text: dados['sku']});
            brand.push({id: dados['marca'], text: dados['marca']});
            category.push({id: dados['category_sku'], text: dados['category_sku']});
            hero.push({id: dados['skherou'], text: dados['hero']});
            majorCategory.push({id: dados['categoria_principal_sku'], text: dados['categoria_principal_sku']});
            abcd.push({id: dados['abcd'], text: dados['abcd']});
            subCategory.push({id: dados['sub_categoria_sku'], text: dados['sub_categoria_sku']});
            plcLocal.push({id: dados['plc_localsku'], text: dados['plc_local']});
        });
        //console.log(sku);
        this.setState({
            sku: sku,
            brand: brand,
            category: category,
            hero: hero,
            majorCategory: majorCategory,
            abcd: abcd,
            subCategory: subCategory,
            plcLocal: plcLocal
        })
    }


    handleChange = e => {
        e.persist();
        const {name, value} = e.target;
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [name]: value
            }
        }));
    };


    handleChange = e => {
        console.log(e);
        e.preventDefault();
        const {value, name} = e.target;
        this.setState(prevState => ({form: {...prevState.form, [name]: value}}));
    };

    render() {
        //   let {data, isLoading} = this.props;
        let isLoading = false;
        let data = [
                {
                    "_id": "3CN601",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac02",
                    "sku": "3CN601",
                    "category_sku": "All Other Lips",
                    "abcd": "D",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All All Other Lips",
                    "hero": "non-hero"
                },
                {
                    "_id": "SNL59R",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadfa",
                    "sku": "SNL59R",
                    "category_sku": "Lip Gloss",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "39MK32",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0c6",
                    "sku": "39MK32",
                    "category_sku": "Concealers & Correctors",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Concealers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKEC16",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab39a",
                    "sku": "SKEC16",
                    "category_sku": "Lip Gloss",
                    "abcd": "B",
                    "marca": "MAC",
                    "plc_local": "4-Launch Event",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKEC04",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab04a",
                    "sku": "SKEC04",
                    "category_sku": "Lip Gloss",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL207",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab30e",
                    "sku": "SKL207",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMMRY1",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaee2",
                    "sku": "SMMRY1",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "MY5R01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafc6",
                    "sku": "MY5R01",
                    "category_sku": "Applicators",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Face Applicators",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMJ101",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab09e",
                    "sku": "SMJ101",
                    "category_sku": "Accessories",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Lash / Adhesives",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF07",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf06",
                    "sku": "SMXF07",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKKM58",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaffa",
                    "sku": "SKKM58",
                    "category_sku": "Lip Liner",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Liner",
                    "hero": "non-hero"
                },
                {
                    "_id": "V16H08",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf42",
                    "sku": "V16H08",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Clinique",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "M8C901",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab12e",
                    "sku": "M8C901",
                    "category_sku": "Applicators",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Face Applicators",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E4601",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab036",
                    "sku": "3E4601",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJFNP1",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad66",
                    "sku": "SJFNP1",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9LLR",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae46",
                    "sku": "SN9LLR",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "39MK21",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0b2",
                    "sku": "39MK21",
                    "category_sku": "Concealers & Correctors",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Concealers",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A7824",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab24a",
                    "sku": "3A7824",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "B3RK01",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674aac96",
                    "sku": "B3RK01",
                    "category_sku": "Styling / Primer Prep",
                    "abcd": "",
                    "marca": "Bumble",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Shine",
                    "hero": "non-hero"
                },
                {
                    "_id": "S4K041",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab332",
                    "sku": "S4K041",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SNL801",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae02",
                    "sku": "SNL801",
                    "category_sku": "Makeup Primers/Finisher/F",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Makeup Primers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C04",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab176",
                    "sku": "SL7C04",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK3713",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab35e",
                    "sku": "SK3713",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Single",
                    "hero": "non-hero"
                },
                {
                    "_id": "3C7K01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab292",
                    "sku": "3C7K01",
                    "category_sku": "Face Powder",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pressed Face Powder",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL210",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab35a",
                    "sku": "SKL210",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMCH56",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacb2",
                    "sku": "SMCH56",
                    "category_sku": "Face Powder",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pressed Face Powder",
                    "hero": "non-hero"
                },
                {
                    "_id": "T7W207",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadfe",
                    "sku": "T7W207",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "Tom Ford Beauty",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "T9NY01",
                    "categoria_principal_sku": "Fragrance",
                    "id": "60cce1a0b4f9c4d0674aaf62",
                    "sku": "T9NY01",
                    "category_sku": "Juices",
                    "abcd": "",
                    "marca": "Tom Ford Beauty",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "EDP",
                    "hero": "non-hero"
                },
                {
                    "_id": "S4K042",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab1ba",
                    "sku": "S4K042",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "PE0W37",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafa6",
                    "sku": "PE0W37",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "LA0301",
                    "categoria_principal_sku": "Fragrance",
                    "id": "60cce1a0b4f9c4d0674ab1f2",
                    "sku": "LA0301",
                    "category_sku": "Juices",
                    "abcd": "",
                    "marca": "Jo Malone London",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "EDT",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJC227",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad32",
                    "sku": "SJC227",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "MPX869",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadbe",
                    "sku": "MPX869",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E7M05",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab072",
                    "sku": "3E7M05",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A7835",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab25e",
                    "sku": "3A7835",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A7841",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab282",
                    "sku": "3A7841",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C10",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab18a",
                    "sku": "SL7C10",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF08",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf0a",
                    "sku": "SMXF08",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E6604",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674ab0e2",
                    "sku": "3E6604",
                    "category_sku": "Lip Treatment",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Lip Treatment",
                    "hero": "non-hero"
                },
                {
                    "_id": "39MK29",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0f2",
                    "sku": "39MK29",
                    "category_sku": "Concealers & Correctors",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Concealers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK3P01",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aad8a",
                    "sku": "SK3P01",
                    "category_sku": "Toners / Clarifyers",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Toners / Clarifyers",
                    "hero": "non-hero"
                },
                {
                    "_id": "43A342",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad76",
                    "sku": "43A342",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Creme de La Mer",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK4101",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae2e",
                    "sku": "SK4101",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMHT01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab086",
                    "sku": "SMHT01",
                    "category_sku": "Accessories",
                    "abcd": "C",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Lash / Adhesives",
                    "hero": "non-hero"
                },
                {
                    "_id": "L9RH01",
                    "categoria_principal_sku": "Fragrance",
                    "id": "60cce1a0b4f9c4d0674ab1e6",
                    "sku": "L9RH01",
                    "category_sku": "Juices",
                    "abcd": "",
                    "marca": "Jo Malone London",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "EDT",
                    "hero": "non-hero"
                },
                {
                    "_id": "SHPH14",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac06",
                    "sku": "SHPH14",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9W02",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadd6",
                    "sku": "SN9W02",
                    "category_sku": "Face Powder",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pressed Face Powder",
                    "hero": "non-hero"
                },
                {
                    "_id": "42H001",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad36",
                    "sku": "42H001",
                    "category_sku": "Brushes",
                    "abcd": "",
                    "marca": "Creme de La Mer",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Face Brushes",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E6301",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674ab0d2",
                    "sku": "3E6301",
                    "category_sku": "Lip Treatment",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Lip Treatment",
                    "hero": "non-hero"
                },
                {
                    "_id": "M8C501",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab142",
                    "sku": "M8C501",
                    "category_sku": "Applicators",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Face Applicators",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF28",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaeaa",
                    "sku": "SMXF28",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "L9RK01",
                    "categoria_principal_sku": "Fragrance",
                    "id": "60cce1a0b4f9c4d0674ab1ea",
                    "sku": "L9RK01",
                    "category_sku": "Juices",
                    "abcd": "",
                    "marca": "Jo Malone London",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "EDT",
                    "hero": "non-hero"
                },
                {
                    "_id": "PY6K01",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aaebe",
                    "sku": "PY6K01",
                    "category_sku": "Serums & Essences",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Serums & Essenc",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKK6KM",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafd2",
                    "sku": "SKK6KM",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A1R01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae76",
                    "sku": "3A1R01",
                    "category_sku": "Brushes",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Eye Brushes",
                    "hero": "non-hero"
                },
                {
                    "_id": "M1EE01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac46",
                    "sku": "M1EE01",
                    "category_sku": "Applicators",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Face Applicators",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF04",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaefa",
                    "sku": "SMXF04",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "39G201",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab1ca",
                    "sku": "39G201",
                    "category_sku": "Mascara",
                    "abcd": "A",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Multi-Purpose",
                    "hero": "hero"
                },
                {
                    "_id": "3A7809",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab1d6",
                    "sku": "3A7809",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "PE0W36",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafaa",
                    "sku": "PE0W36",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJC223",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadc6",
                    "sku": "SJC223",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9R01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae56",
                    "sku": "SN9R01",
                    "category_sku": "Eyeshadow",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJ4X03",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad1a",
                    "sku": "SJ4X03",
                    "category_sku": "All Other Eye Makeup",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All All Other Eye Makeup",
                    "hero": "non-hero"
                },
                {
                    "_id": "SRM53T",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac42",
                    "sku": "SRM53T",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "MMJH27",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad3e",
                    "sku": "MMJH27",
                    "category_sku": "All Other Face MakeUp",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Face Makeup",
                    "hero": "non-hero"
                },
                {
                    "_id": "MMJH14",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad4e",
                    "sku": "MMJH14",
                    "category_sku": "All Other Face MakeUp",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Face Makeup",
                    "hero": "non-hero"
                },
                {
                    "_id": "SELF01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aabe6",
                    "sku": "SELF01",
                    "category_sku": "All Other Face MakeUp",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Face Makeup",
                    "hero": "non-hero"
                },
                {
                    "_id": "B3R001",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674aac8e",
                    "sku": "B3R001",
                    "category_sku": "Leave In Treatment",
                    "abcd": "D",
                    "marca": "Bumble",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Color Care",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9T50",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae6a",
                    "sku": "SN9T50",
                    "category_sku": "Eye Liners",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "MPX858",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2aa",
                    "sku": "MPX858",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CFX09",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab20a",
                    "sku": "3CFX09",
                    "category_sku": "Lip Liner",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Liner",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMKF01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0de",
                    "sku": "SMKF01",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C41",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab1be",
                    "sku": "SL7C41",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "PE0W53",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf9e",
                    "sku": "PE0W53",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E7K01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab106",
                    "sku": "3E7K01",
                    "category_sku": "Cross Application Sets",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Application Set",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL235",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab322",
                    "sku": "SKL235",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMK601",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0a2",
                    "sku": "SMK601",
                    "category_sku": "Cross Category Sets",
                    "abcd": "B",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "MPX845",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab246",
                    "sku": "MPX845",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJ4X04",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacd6",
                    "sku": "SJ4X04",
                    "category_sku": "All Other Eye Makeup",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All All Other Eye Makeup",
                    "hero": "non-hero"
                },
                {
                    "_id": "V1G801",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aaf2a",
                    "sku": "V1G801",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "Clinique",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "B3RL01",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674aac9a",
                    "sku": "B3RL01",
                    "category_sku": "Styling / Primer Prep",
                    "abcd": "",
                    "marca": "Bumble",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Shine",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CTY02",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac26",
                    "sku": "3CTY02",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E7M06",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab076",
                    "sku": "3E7M06",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK3707",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab336",
                    "sku": "SK3707",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Single",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL238",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab37a",
                    "sku": "SKL238",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "MKEH01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadaa",
                    "sku": "MKEH01",
                    "category_sku": "Accessories",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Bags / Totes",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C05",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab17a",
                    "sku": "SL7C05",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXNY1",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf4e",
                    "sku": "SMXNY1",
                    "category_sku": "Cross Application Sets",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Application Set",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A7839",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab276",
                    "sku": "3A7839",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMCCLC",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaca6",
                    "sku": "SMCCLC",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E4E01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab06a",
                    "sku": "3E4E01",
                    "category_sku": "Bronzer",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Bronzer",
                    "hero": "non-hero"
                },
                {
                    "_id": "MPX863",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadb6",
                    "sku": "MPX863",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "PE0WC6",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf8e",
                    "sku": "PE0WC6",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMKH01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaed6",
                    "sku": "SMKH01",
                    "category_sku": "Lipsticks",
                    "abcd": "C",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "PE0WC0",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf96",
                    "sku": "PE0WC0",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E4603",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab046",
                    "sku": "3E4603",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK3724",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab33e",
                    "sku": "SK3724",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pan Only",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E4607",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab05a",
                    "sku": "3E4607",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKEC17",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab3a2",
                    "sku": "SKEC17",
                    "category_sku": "Lip Gloss",
                    "abcd": "C",
                    "marca": "MAC",
                    "plc_local": "4-Launch Event",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "MPX860",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad96",
                    "sku": "MPX860",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF09",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf0e",
                    "sku": "SMXF09",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKKC7H",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafe6",
                    "sku": "SKKC7H",
                    "category_sku": "Lip Gloss",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "SNHP19",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aade6",
                    "sku": "SNHP19",
                    "category_sku": "Liquid Lip",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL242",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab376",
                    "sku": "SKL242",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK6805",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac4a",
                    "sku": "SK6805",
                    "category_sku": "Lip Gloss",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A1T01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae4a",
                    "sku": "3A1T01",
                    "category_sku": "Eye Liners",
                    "abcd": "A",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "PE0WCA",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf8a",
                    "sku": "PE0WCA",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMHX01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab08e",
                    "sku": "SMHX01",
                    "category_sku": "Accessories",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Lash / Adhesives",
                    "hero": "non-hero"
                },
                {
                    "_id": "SHPH11",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aabee",
                    "sku": "SHPH11",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CN504",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aabfa",
                    "sku": "3CN504",
                    "category_sku": "Blush",
                    "abcd": "D",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Blush",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL225",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2f2",
                    "sku": "SKL225",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "PE0W05",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafba",
                    "sku": "PE0W05",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL223",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2e2",
                    "sku": "SKL223",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK3Y01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aada6",
                    "sku": "SK3Y01",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK3718",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2ae",
                    "sku": "SK3718",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Single",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF06",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf02",
                    "sku": "SMXF06",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "PE0W38",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafa2",
                    "sku": "PE0W38",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "ZFJY01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab242",
                    "sku": "ZFJY01",
                    "category_sku": "Accessories",
                    "abcd": "D",
                    "marca": "Clinique",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Tools",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJC226",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad2e",
                    "sku": "SJC226",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "39MK22",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0b6",
                    "sku": "39MK22",
                    "category_sku": "Concealers & Correctors",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Concealers",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A7836",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab26e",
                    "sku": "3A7836",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "PE0W99",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf9a",
                    "sku": "PE0W99",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL216",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2b2",
                    "sku": "SKL216",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "MPX842",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab26a",
                    "sku": "MPX842",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CTY07",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aace6",
                    "sku": "3CTY07",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "SHP301",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab22a",
                    "sku": "SHP301",
                    "category_sku": "Accessories",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Accessories",
                    "hero": "non-hero"
                },
                {
                    "_id": "B3RJ01",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674aac92",
                    "sku": "B3RJ01",
                    "category_sku": "Styling / Primer Prep",
                    "abcd": "",
                    "marca": "Bumble",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Shine",
                    "hero": "non-hero"
                },
                {
                    "_id": "PE0W16",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafae",
                    "sku": "PE0W16",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9R03",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae5e",
                    "sku": "SN9R03",
                    "category_sku": "Eyeshadow",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CFT03",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab232",
                    "sku": "3CFT03",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Gel Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "C6H507",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac82",
                    "sku": "C6H507",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "Smashbox",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CTY06",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aace2",
                    "sku": "3CTY06",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKJK01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab01e",
                    "sku": "SKJK01",
                    "category_sku": "Mascara",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Mascara",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C07",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab182",
                    "sku": "SL7C07",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CH801",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674ab226",
                    "sku": "3CH801",
                    "category_sku": "Lip Treatment",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Lip Treatment",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C57",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab126",
                    "sku": "SL7C57",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SRK201",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac3e",
                    "sku": "SRK201",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "V16H09",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf3e",
                    "sku": "V16H09",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Clinique",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E4602",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab042",
                    "sku": "3E4602",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF18",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae8a",
                    "sku": "SMXF18",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SHPH13",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aabfe",
                    "sku": "SHPH13",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CTY01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac1e",
                    "sku": "3CTY01",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "C6H504",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacee",
                    "sku": "C6H504",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "Smashbox",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "C6GY01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacf6",
                    "sku": "C6GY01",
                    "category_sku": "Makeup Primers/Finisher/F",
                    "abcd": "",
                    "marca": "Smashbox",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Makeup Primers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL205",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2ea",
                    "sku": "SKL205",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF15",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaec6",
                    "sku": "SMXF15",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CFX04",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab206",
                    "sku": "3CFX04",
                    "category_sku": "Lip Liner",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Liner",
                    "hero": "non-hero"
                },
                {
                    "_id": "39MK34",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0be",
                    "sku": "39MK34",
                    "category_sku": "Concealers & Correctors",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Concealers",
                    "hero": "non-hero"
                },
                {
                    "_id": "S4K043",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab1c2",
                    "sku": "S4K043",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMWWY1",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaeea",
                    "sku": "SMWWY1",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKKA7G",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafe2",
                    "sku": "SKKA7G",
                    "category_sku": "Lip Gloss",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL239",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab37e",
                    "sku": "SKL239",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C08",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab186",
                    "sku": "SL7C08",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL231",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2fa",
                    "sku": "SKL231",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL229",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab306",
                    "sku": "SKL229",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "39MK35",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab06e",
                    "sku": "39MK35",
                    "category_sku": "Concealers & Correctors",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Concealers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C35",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab19e",
                    "sku": "SL7C35",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SLFC03",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab13e",
                    "sku": "SLFC03",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Dual Ended Eyeliners",
                    "hero": "non-hero"
                },
                {
                    "_id": "SLXH10",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab15a",
                    "sku": "SLXH10",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL213",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab34e",
                    "sku": "SKL213",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "AYCK01",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674ab1a2",
                    "sku": "AYCK01",
                    "category_sku": "Shampoo",
                    "abcd": "A",
                    "marca": "Aveda",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Color Enhancing",
                    "hero": "non-hero"
                },
                {
                    "_id": "39G301",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab122",
                    "sku": "39G301",
                    "category_sku": "Mascara",
                    "abcd": "A",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Multi-Purpose",
                    "hero": "hero"
                },
                {
                    "_id": "SL7C06",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab17e",
                    "sku": "SL7C06",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF25",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae9e",
                    "sku": "SMXF25",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKK9K5",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafde",
                    "sku": "SKK9K5",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "3C7L01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab23a",
                    "sku": "3C7L01",
                    "category_sku": "Makeup Primers/Finisher/F",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "AllOther Primers/Finisher",
                    "hero": "non-hero"
                },
                {
                    "_id": "B3N001",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674aad0e",
                    "sku": "B3N001",
                    "category_sku": "Conditioner",
                    "abcd": "C",
                    "marca": "Bumble",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Color Care",
                    "hero": "non-hero"
                },
                {
                    "_id": "SLXG01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab156",
                    "sku": "SLXG01",
                    "category_sku": "All Other Face Color",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Face Color",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL215",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab362",
                    "sku": "SKL215",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "S77809",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae12",
                    "sku": "S77809",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJC224",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad7a",
                    "sku": "SJC224",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "C6H501",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacf2",
                    "sku": "C6H501",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "Smashbox",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "V16H03",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf52",
                    "sku": "V16H03",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Clinique",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "M45C01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab1fa",
                    "sku": "M45C01",
                    "category_sku": "Applicators",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Lip Applicators",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C02",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab29a",
                    "sku": "SL7C02",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E0801",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae7a",
                    "sku": "3E0801",
                    "category_sku": "Cross Application Sets",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Application Set",
                    "hero": "non-hero"
                },
                {
                    "_id": "PW38Y1",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aaf22",
                    "sku": "PW38Y1",
                    "category_sku": "Serums & Essences",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Serums & Essenc",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E6503",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674ab0da",
                    "sku": "3E6503",
                    "category_sku": "Lip Treatment",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Lip Treatment",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9LLP",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae42",
                    "sku": "SN9LLP",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A7810",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab23e",
                    "sku": "3A7810",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E7N04",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad8e",
                    "sku": "3E7N04",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "SNL59N",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadf2",
                    "sku": "SNL59N",
                    "category_sku": "Lip Gloss",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "SLFC02",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab136",
                    "sku": "SLFC02",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Dual Ended Eyeliners",
                    "hero": "non-hero"
                },
                {
                    "_id": "B3PY01",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674aac8a",
                    "sku": "B3PY01",
                    "category_sku": "Leave In Treatment",
                    "abcd": "C",
                    "marca": "Bumble",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Color Care",
                    "hero": "non-hero"
                },
                {
                    "_id": "43CW01",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aadca",
                    "sku": "43CW01",
                    "category_sku": "Cross Major Category Sets",
                    "abcd": "C",
                    "marca": "Creme de La Mer",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Major Category",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJFP49",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadce",
                    "sku": "SJFP49",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF29",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaeae",
                    "sku": "SMXF29",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL234",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab312",
                    "sku": "SKL234",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF21",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae96",
                    "sku": "SMXF21",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "PPPX01",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aaf7e",
                    "sku": "PPPX01",
                    "category_sku": "Eye Treatment",
                    "abcd": "D",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eye Treatment",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKG7Y0",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafce",
                    "sku": "SKG7Y0",
                    "category_sku": "Cross Major Category Sets",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Major Category",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CTY09",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacca",
                    "sku": "3CTY09",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A7837",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab272",
                    "sku": "3A7837",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL227",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab302",
                    "sku": "SKL227",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SNHP17",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aade2",
                    "sku": "SNHP17",
                    "category_sku": "Liquid Lip",
                    "abcd": "C",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C03",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab266",
                    "sku": "SL7C03",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL240",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab382",
                    "sku": "SKL240",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF26",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaea2",
                    "sku": "SMXF26",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "43A322",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad5e",
                    "sku": "43A322",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Creme de La Mer",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "42KC01",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aad46",
                    "sku": "42KC01",
                    "category_sku": "Cross Category Sets",
                    "abcd": "C",
                    "marca": "Creme de La Mer",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKGPY0",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaeb6",
                    "sku": "SKGPY0",
                    "category_sku": "Cross Major Category Sets",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Major Category",
                    "hero": "non-hero"
                },
                {
                    "_id": "SHPH09",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad1e",
                    "sku": "SHPH09",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK3721",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab372",
                    "sku": "SK3721",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Single",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E7N03",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad86",
                    "sku": "3E7N03",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "SNWT01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae0a",
                    "sku": "SNWT01",
                    "category_sku": "Brushes",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Eye Brushes",
                    "hero": "non-hero"
                },
                {
                    "_id": "M85E01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf86",
                    "sku": "M85E01",
                    "category_sku": "Accessories",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Accessories",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF30",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaeb2",
                    "sku": "SMXF30",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CFX10",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab20e",
                    "sku": "3CFX10",
                    "category_sku": "Lip Liner",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Liner",
                    "hero": "non-hero"
                },
                {
                    "_id": "S3HT5J",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab396",
                    "sku": "S3HT5J",
                    "category_sku": "Lip Gloss",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "4-Launch Event",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "T9AT01",
                    "categoria_principal_sku": "Fragrance",
                    "id": "60cce1a0b4f9c4d0674ab39e",
                    "sku": "T9AT01",
                    "category_sku": "Juices",
                    "abcd": "C",
                    "marca": "Tom Ford Beauty",
                    "plc_local": "4-Launch Event",
                    "sub_categoria_sku": "EDP",
                    "hero": "non-hero"
                },
                {
                    "_id": "AY5C01",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674ab32e",
                    "sku": "AY5C01",
                    "category_sku": "Leave In Treatment",
                    "abcd": "",
                    "marca": "Aveda",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Moisture- Oil Infused",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL228",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab316",
                    "sku": "SKL228",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "L9RG01",
                    "categoria_principal_sku": "Fragrance",
                    "id": "60cce1a0b4f9c4d0674ab1e2",
                    "sku": "L9RG01",
                    "category_sku": "Juices",
                    "abcd": "",
                    "marca": "Jo Malone London",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "EDT",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMCCLA",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaca2",
                    "sku": "SMCCLA",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "M45F01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab1fe",
                    "sku": "M45F01",
                    "category_sku": "Applicators",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Eye Applicators",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK3723",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab326",
                    "sku": "SK3723",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pan Only",
                    "hero": "non-hero"
                },
                {
                    "_id": "LCTH01",
                    "categoria_principal_sku": "Fragrance",
                    "id": "60cce1a0b4f9c4d0674ab096",
                    "sku": "LCTH01",
                    "category_sku": "Juices",
                    "abcd": "",
                    "marca": "Jo Malone London",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Parfum / Perfume",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJFP50",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadd2",
                    "sku": "SJFP50",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "AYPN01",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674ab212",
                    "sku": "AYPN01",
                    "category_sku": "Styling Tools",
                    "abcd": "",
                    "marca": "Aveda",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Styling Tools",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMK701",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0a6",
                    "sku": "SMK701",
                    "category_sku": "Cross Category Sets",
                    "abcd": "B",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "44X201",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aae36",
                    "sku": "44X201",
                    "category_sku": "Cross Application Sets",
                    "abcd": "C",
                    "marca": "Creme de La Mer",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Application  Se",
                    "hero": "non-hero"
                },
                {
                    "_id": "PY4J01",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aaeca",
                    "sku": "PY4J01",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "PE0W10",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafb6",
                    "sku": "PE0W10",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "39MK27",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab102",
                    "sku": "39MK27",
                    "category_sku": "Concealers & Correctors",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Concealers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKK8KP",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafda",
                    "sku": "SKK8KP",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9R02",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae5a",
                    "sku": "SN9R02",
                    "category_sku": "Eyeshadow",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL201",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab002",
                    "sku": "SKL201",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF17",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae86",
                    "sku": "SMXF17",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK6P16",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac2e",
                    "sku": "SK6P16",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SFM8HF",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacfe",
                    "sku": "SFM8HF",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "MPX838",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab22e",
                    "sku": "MPX838",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "SNL59T",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab10e",
                    "sku": "SNL59T",
                    "category_sku": "Lip Gloss",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL241",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab386",
                    "sku": "SKL241",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SCJX03",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac22",
                    "sku": "SCJX03",
                    "category_sku": "All Other Face MakeUp",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Face Makeup",
                    "hero": "non-hero"
                },
                {
                    "_id": "MMJH26",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad42",
                    "sku": "MMJH26",
                    "category_sku": "All Other Face MakeUp",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Face Makeup",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJJN7L",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae3a",
                    "sku": "SJJN7L",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C14",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab192",
                    "sku": "SL7C14",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CGR01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab222",
                    "sku": "3CGR01",
                    "category_sku": "Lip Gloss",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "B3W101",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674ab016",
                    "sku": "B3W101",
                    "category_sku": "Conditioner",
                    "abcd": "D",
                    "marca": "Bumble",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Moisture- Oil Infused",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E7M03",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0fa",
                    "sku": "3E7M03",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A7801",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab1ce",
                    "sku": "3A7801",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SHPH12",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aabf2",
                    "sku": "SHPH12",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CN503",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aabf6",
                    "sku": "3CN503",
                    "category_sku": "Blush",
                    "abcd": "D",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Blush",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL230",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2fe",
                    "sku": "SKL230",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK6M15",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac56",
                    "sku": "SK6M15",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMHR01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab082",
                    "sku": "SMHR01",
                    "category_sku": "Accessories",
                    "abcd": "C",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Lash / Adhesives",
                    "hero": "non-hero"
                },
                {
                    "_id": "MPX857",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2ce",
                    "sku": "MPX857",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "S7HH01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aabe2",
                    "sku": "S7HH01",
                    "category_sku": "Brushes",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Face Brushes",
                    "hero": "non-hero"
                },
                {
                    "_id": "T8EG01",
                    "categoria_principal_sku": "Fragrance",
                    "id": "60cce1a0b4f9c4d0674aaf66",
                    "sku": "T8EG01",
                    "category_sku": "Juices",
                    "abcd": "",
                    "marca": "Tom Ford Beauty",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "EDP",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL209",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab36a",
                    "sku": "SKL209",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMKG01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafca",
                    "sku": "SMKG01",
                    "category_sku": "Lip Gloss",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "V1FX01",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aaf2e",
                    "sku": "V1FX01",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "Clinique",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJ4X01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad12",
                    "sku": "SJ4X01",
                    "category_sku": "All Other Eye Makeup",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All All Other Eye Makeup",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL211",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2e6",
                    "sku": "SKL211",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A1Y01",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aacc6",
                    "sku": "3A1Y01",
                    "category_sku": "Moisturizers",
                    "abcd": "B",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Moisturizers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKGTY0",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaeba",
                    "sku": "SKGTY0",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A7828",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab24e",
                    "sku": "3A7828",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E7N02",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad82",
                    "sku": "3E7N02",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "PWFP01",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aaf1e",
                    "sku": "PWFP01",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "SLY6Y0",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab15e",
                    "sku": "SLY6Y0",
                    "category_sku": "Cross Application Sets",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Application Set",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9T53",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae22",
                    "sku": "SN9T53",
                    "category_sku": "Eye Liners",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CTY10",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac86",
                    "sku": "3CTY10",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK6P14",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac72",
                    "sku": "SK6P14",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF05",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaefe",
                    "sku": "SMXF05",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL233",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2d6",
                    "sku": "SKL233",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK6M7R",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac62",
                    "sku": "SK6M7R",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "MRNG01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0ae",
                    "sku": "MRNG01",
                    "category_sku": "Applicators",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Eye Applicators",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9NKF",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae52",
                    "sku": "SN9NKF",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9R05",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae66",
                    "sku": "SN9R05",
                    "category_sku": "Eyeshadow",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "S28501",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab11e",
                    "sku": "S28501",
                    "category_sku": "Accessories",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Empty Compacts",
                    "hero": "non-hero"
                },
                {
                    "_id": "SLWJ01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab14e",
                    "sku": "SLWJ01",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Palette",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E0901",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab026",
                    "sku": "3E0901",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E7M04",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0fe",
                    "sku": "3E7M04",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "S4K040",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab31e",
                    "sku": "S4K040",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKGWY0",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf26",
                    "sku": "SKGWY0",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL214",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab33a",
                    "sku": "SKL214",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN8J04",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae3e",
                    "sku": "SN8J04",
                    "category_sku": "Lipsticks",
                    "abcd": "C",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A3W01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab14a",
                    "sku": "3A3W01",
                    "category_sku": "Brushes",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Face Brushes",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK6N29",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac6e",
                    "sku": "SK6N29",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJGG27",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae2a",
                    "sku": "SJGG27",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "S4K047",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab11a",
                    "sku": "S4K047",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK3725",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab34a",
                    "sku": "SK3725",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pan Only",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJC222",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad7e",
                    "sku": "SJC222",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "SLFC01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab132",
                    "sku": "SLFC01",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Dual Ended Eyeliners",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMHY01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab092",
                    "sku": "SMHY01",
                    "category_sku": "Accessories",
                    "abcd": "C",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Lash / Adhesives",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMCG01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacae",
                    "sku": "SMCG01",
                    "category_sku": "Eyeshadow",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Palette",
                    "hero": "non-hero"
                },
                {
                    "_id": "MPX841",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab296",
                    "sku": "MPX841",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "MMJH16",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad4a",
                    "sku": "MMJH16",
                    "category_sku": "All Other Face MakeUp",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Face Makeup",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKHJY0",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab066",
                    "sku": "SKHJY0",
                    "category_sku": "Cross Application Sets",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Application Set",
                    "hero": "non-hero"
                },
                {
                    "_id": "T6XW01",
                    "categoria_principal_sku": "Fragrance",
                    "id": "60cce1a0b4f9c4d0674ab1f6",
                    "sku": "T6XW01",
                    "category_sku": "Fragranced Home Ancillari",
                    "abcd": "",
                    "marca": "Tom Ford Beauty",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Candles",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF02",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaef2",
                    "sku": "SMXF02",
                    "category_sku": "Lipsticks",
                    "abcd": "C",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E7N01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab10a",
                    "sku": "3E7N01",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CFX03",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab202",
                    "sku": "3CFX03",
                    "category_sku": "Lip Liner",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Liner",
                    "hero": "non-hero"
                },
                {
                    "_id": "SELF02",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad56",
                    "sku": "SELF02",
                    "category_sku": "All Other Face MakeUp",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Face Makeup",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK6M32",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac5a",
                    "sku": "SK6M32",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF10",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf12",
                    "sku": "SMXF10",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "PE0W04",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafbe",
                    "sku": "PE0W04",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C13",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab18e",
                    "sku": "SL7C13",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL206",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2de",
                    "sku": "SKL206",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CW601",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aac9e",
                    "sku": "3CW601",
                    "category_sku": "Lip Treatment",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Lip Treatment",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL202",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab006",
                    "sku": "SKL202",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKKE7J",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafea",
                    "sku": "SKKE7J",
                    "category_sku": "Lip Gloss",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9M5K",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae72",
                    "sku": "SN9M5K",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMK801",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674ab0aa",
                    "sku": "SMK801",
                    "category_sku": "Watery /Treatment/Essence",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Watery /Treatment/Ess",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMFF01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacba",
                    "sku": "SMFF01",
                    "category_sku": "Applicators",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Eye Applicators",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A7830",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab252",
                    "sku": "3A7830",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL224",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2ee",
                    "sku": "SKL224",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "B3TA01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacbe",
                    "sku": "B3TA01",
                    "category_sku": "Face Powder",
                    "abcd": "",
                    "marca": "Becca",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Loose Face Powder",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKEC09",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab022",
                    "sku": "SKEC09",
                    "category_sku": "Lip Gloss",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "39MK23",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0ba",
                    "sku": "39MK23",
                    "category_sku": "Concealers & Correctors",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Concealers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF14",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaece",
                    "sku": "SMXF14",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "C6GT01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad06",
                    "sku": "C6GT01",
                    "category_sku": "Makeup Primers/Finisher/F",
                    "abcd": "",
                    "marca": "Smashbox",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Makeup Primers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C15",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab196",
                    "sku": "SL7C15",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SCJX04",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aabde",
                    "sku": "SCJX04",
                    "category_sku": "All Other Face MakeUp",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Face Makeup",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJFNP3",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad6a",
                    "sku": "SJFNP3",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C24",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab19a",
                    "sku": "SL7C24",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "MPX844",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab262",
                    "sku": "MPX844",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "S77811",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad2a",
                    "sku": "S77811",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "S4K044",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab1c6",
                    "sku": "S4K044",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "PE0W01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf7a",
                    "sku": "PE0W01",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E4606",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab056",
                    "sku": "3E4606",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "39MK28",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0f6",
                    "sku": "39MK28",
                    "category_sku": "Concealers & Correctors",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Concealers",
                    "hero": "non-hero"
                },
                {
                    "_id": "B3MY01",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674ab1ee",
                    "sku": "B3MY01",
                    "category_sku": "Shampoo",
                    "abcd": "C",
                    "marca": "Bumble",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Color Care",
                    "hero": "non-hero"
                },
                {
                    "_id": "SLXF01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab152",
                    "sku": "SLXF01",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Palette",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMHM01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab03a",
                    "sku": "SMHM01",
                    "category_sku": "Accessories",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Lash / Adhesives",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL218",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2be",
                    "sku": "SKL218",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SR0N04",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac36",
                    "sku": "SR0N04",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "AYCP01",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674ab1a6",
                    "sku": "AYCP01",
                    "category_sku": "Conditioner",
                    "abcd": "A",
                    "marca": "Aveda",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Color Enhancing",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK4001",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad5a",
                    "sku": "SK4001",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9W01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae1a",
                    "sku": "SN9W01",
                    "category_sku": "Face Powder",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pressed Face Powder",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJC225",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad72",
                    "sku": "SJC225",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9T52",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae26",
                    "sku": "SN9T52",
                    "category_sku": "Eye Liners",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMHN01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab07a",
                    "sku": "SMHN01",
                    "category_sku": "Accessories",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Lash / Adhesives",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK6N24",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac6a",
                    "sku": "SK6N24",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK6N05",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac66",
                    "sku": "SK6N05",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CTY08",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacd2",
                    "sku": "3CTY08",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "S77810",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae16",
                    "sku": "S77810",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "MPX839",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab286",
                    "sku": "MPX839",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A7840",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab27e",
                    "sku": "3A7840",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "3C0201",
                    "categoria_principal_sku": "Other",
                    "id": "60cce1a0b4f9c4d0674ab28e",
                    "sku": "3C0201",
                    "category_sku": "Accessories",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Accessories",
                    "hero": "non-hero"
                },
                {
                    "_id": "39MK30",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0e6",
                    "sku": "39MK30",
                    "category_sku": "Concealers & Correctors",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Concealers",
                    "hero": "non-hero"
                },
                {
                    "_id": "44CG01",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aae32",
                    "sku": "44CG01",
                    "category_sku": "Moisturizers",
                    "abcd": "",
                    "marca": "Creme de La Mer",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Moisturizers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SR0N06",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac3a",
                    "sku": "SR0N06",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "S77812",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad26",
                    "sku": "S77812",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF11",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf16",
                    "sku": "SMXF11",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E7M02",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0ee",
                    "sku": "3E7M02",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "MMJH28",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad3a",
                    "sku": "MMJH28",
                    "category_sku": "All Other Face MakeUp",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Face Makeup",
                    "hero": "non-hero"
                },
                {
                    "_id": "C6H509",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac1a",
                    "sku": "C6H509",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "Smashbox",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E4605",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab052",
                    "sku": "3E4605",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "C6H505",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacea",
                    "sku": "C6H505",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "Smashbox",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF19",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae8e",
                    "sku": "SMXF19",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "V19P01",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aaf36",
                    "sku": "V19P01",
                    "category_sku": "Whitening Target Treatmen",
                    "abcd": "",
                    "marca": "Clinique",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Whitening Target Trea",
                    "hero": "non-hero"
                },
                {
                    "_id": "AYG401",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674ab1b2",
                    "sku": "AYG401",
                    "category_sku": "Styling / Primer Prep",
                    "abcd": "B",
                    "marca": "Aveda",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Curl / Wave Enhancing",
                    "hero": "non-hero"
                },
                {
                    "_id": "MMJH11",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad52",
                    "sku": "MMJH11",
                    "category_sku": "All Other Face MakeUp",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Face Makeup",
                    "hero": "non-hero"
                },
                {
                    "_id": "SNH801",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadde",
                    "sku": "SNH801",
                    "category_sku": "Mascara",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Volumizing",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMMNY1",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaede",
                    "sku": "SMMNY1",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL219",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2c2",
                    "sku": "SKL219",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK6P18",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac76",
                    "sku": "SK6P18",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CTY03",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac7e",
                    "sku": "3CTY03",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKKL45",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaff6",
                    "sku": "SKKL45",
                    "category_sku": "Lip Liner",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Liner",
                    "hero": "non-hero"
                },
                {
                    "_id": "PY4L01",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aaec2",
                    "sku": "PY4L01",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "V0C401",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aaf5e",
                    "sku": "V0C401",
                    "category_sku": "Moisturizers",
                    "abcd": "",
                    "marca": "Clinique",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Moisturizers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF12",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaed2",
                    "sku": "SMXF12",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SNWW01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae0e",
                    "sku": "SNWW01",
                    "category_sku": "Brushes",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Face Brushes",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKH3Y0",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab05e",
                    "sku": "SKH3Y0",
                    "category_sku": "Mascara",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Mascara",
                    "hero": "non-hero"
                },
                {
                    "_id": "C6H510",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac16",
                    "sku": "C6H510",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "Smashbox",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "S6GC01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac52",
                    "sku": "S6GC01",
                    "category_sku": "Brushes",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Eye Brushes",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL236",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab31a",
                    "sku": "SKL236",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SNL59M",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadee",
                    "sku": "SNL59M",
                    "category_sku": "Lip Gloss",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E7M07",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab112",
                    "sku": "3E7M07",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJ4X02",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad16",
                    "sku": "SJ4X02",
                    "category_sku": "All Other Eye Makeup",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All All Other Eye Makeup",
                    "hero": "non-hero"
                },
                {
                    "_id": "S77815",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac32",
                    "sku": "S77815",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "PE0W42",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafc2",
                    "sku": "PE0W42",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A7832",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab256",
                    "sku": "3A7832",
                    "category_sku": "Foundation",
                    "abcd": "D",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL232",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2a6",
                    "sku": "SKL232",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "MPX846",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab30a",
                    "sku": "MPX846",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK3W01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad9e",
                    "sku": "SK3W01",
                    "category_sku": "All Other Face Color",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Palette",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9X01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadda",
                    "sku": "SN9X01",
                    "category_sku": "Accessories",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Lash / Adhesives",
                    "hero": "non-hero"
                },
                {
                    "_id": "V2AWY1",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aaf76",
                    "sku": "V2AWY1",
                    "category_sku": "Cross Major Category Sets",
                    "abcd": "",
                    "marca": "Clinique",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Major Category",
                    "hero": "non-hero"
                },
                {
                    "_id": "AYW301",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674ab216",
                    "sku": "AYW301",
                    "category_sku": "All Other Other Haircare",
                    "abcd": "",
                    "marca": "Aveda",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other",
                    "hero": "non-hero"
                },
                {
                    "_id": "S6GJ01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac4e",
                    "sku": "S6GJ01",
                    "category_sku": "Applicators",
                    "abcd": "C",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Face Applicators",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF03",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaef6",
                    "sku": "SMXF03",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E0C01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab032",
                    "sku": "3E0C01",
                    "category_sku": "Cross Application Sets",
                    "abcd": "D",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Application Set",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKEY01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab3a6",
                    "sku": "SKEY01",
                    "category_sku": "Makeup Primers/Finisher/F",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "4-Launch Event",
                    "sub_categoria_sku": "Finishers/Fixers/Setters",
                    "hero": "non-hero"
                },
                {
                    "_id": "SNL59P",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadf6",
                    "sku": "SNL59P",
                    "category_sku": "Lip Gloss",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CN603",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac0e",
                    "sku": "3CN603",
                    "category_sku": "All Other Lips",
                    "abcd": "D",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All All Other Lips",
                    "hero": "non-hero"
                },
                {
                    "_id": "V16H01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf5a",
                    "sku": "V16H01",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Clinique",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "T8EF01",
                    "categoria_principal_sku": "Fragrance",
                    "id": "60cce1a0b4f9c4d0674aaf6a",
                    "sku": "T8EF01",
                    "category_sku": "Juices",
                    "abcd": "",
                    "marca": "Tom Ford Beauty",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "EDP",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A2Y05",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab29e",
                    "sku": "3A2Y05",
                    "category_sku": "Concealers & Correctors",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Concealers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK6M3L",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac5e",
                    "sku": "SK6M3L",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CTY05",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacda",
                    "sku": "3CTY05",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "C6GX01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacfa",
                    "sku": "C6GX01",
                    "category_sku": "Makeup Primers/Finisher/F",
                    "abcd": "",
                    "marca": "Smashbox",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Makeup Primers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK3X01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aada2",
                    "sku": "SK3X01",
                    "category_sku": "Lip Gloss",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF27",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaea6",
                    "sku": "SMXF27",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL203",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab00a",
                    "sku": "SKL203",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "V1CT01",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aaf32",
                    "sku": "V1CT01",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "Clinique",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "B3W401",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674ab012",
                    "sku": "B3W401",
                    "category_sku": "Conditioner",
                    "abcd": "D",
                    "marca": "Bumble",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Moisture- Oil Infused",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL226",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2f6",
                    "sku": "SKL226",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKGGY0",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaee6",
                    "sku": "SKGGY0",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E4G01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0ce",
                    "sku": "3E4G01",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Palette",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKK7KN",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafd6",
                    "sku": "SKK7KN",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL212",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab356",
                    "sku": "SKL212",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SF5M01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab32a",
                    "sku": "SF5M01",
                    "category_sku": "Brushes",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Face Brushes",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CKX01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab21e",
                    "sku": "3CKX01",
                    "category_sku": "Cross Application Sets",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Application Set",
                    "hero": "non-hero"
                },
                {
                    "_id": "PE0WC5",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf92",
                    "sku": "PE0WC5",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E4604",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab04e",
                    "sku": "3E4604",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL220",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2c6",
                    "sku": "SKL220",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E7M08",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab1de",
                    "sku": "3E7M08",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL208",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2d2",
                    "sku": "SKL208",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "MPX861",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadae",
                    "sku": "MPX861",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "V29RY1",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aaf72",
                    "sku": "V29RY1",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "Clinique",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CLF01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab21a",
                    "sku": "3CLF01",
                    "category_sku": "Accessories",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Bags / Totes",
                    "hero": "non-hero"
                },
                {
                    "_id": "V16H05",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf4a",
                    "sku": "V16H05",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Clinique",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "S4K046",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab116",
                    "sku": "S4K046",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "AYFM01",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674ab1aa",
                    "sku": "AYFM01",
                    "category_sku": "Styling / Primer Prep",
                    "abcd": "",
                    "marca": "Aveda",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Thickening",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A7806",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab1d2",
                    "sku": "3A7806",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C63",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab12a",
                    "sku": "SL7C63",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "MPX862",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadb2",
                    "sku": "MPX862",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "B38H01",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674ab38e",
                    "sku": "B38H01",
                    "category_sku": "Styling / Primer Prep",
                    "abcd": "B",
                    "marca": "Bumble",
                    "plc_local": "4-Launch Event",
                    "sub_categoria_sku": "Curl / Wave Enhancing",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9R04",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae62",
                    "sku": "SN9R04",
                    "category_sku": "Eyeshadow",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E7M01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0ea",
                    "sku": "3E7M01",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "MPX870",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadc2",
                    "sku": "MPX870",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKKN97",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaffe",
                    "sku": "SKKN97",
                    "category_sku": "Lip Liner",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Liner",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C55",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab16e",
                    "sku": "SL7C55",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9T54",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae1e",
                    "sku": "SN9T54",
                    "category_sku": "Eye Liners",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "S5JM05",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab27a",
                    "sku": "S5JM05",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cushion Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9LLT",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae4e",
                    "sku": "SN9LLT",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "PE0W12",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafb2",
                    "sku": "PE0W12",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Estee Lauder",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMHW01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab08a",
                    "sku": "SMHW01",
                    "category_sku": "Accessories",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Lash / Adhesives",
                    "hero": "non-hero"
                },
                {
                    "_id": "MPX867",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadba",
                    "sku": "MPX867",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "SNHP21",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aadea",
                    "sku": "SNHP21",
                    "category_sku": "Liquid Lip",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "S77814",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac7a",
                    "sku": "S77814",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMHP01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab07e",
                    "sku": "SMHP01",
                    "category_sku": "Accessories",
                    "abcd": "C",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Lash / Adhesives",
                    "hero": "non-hero"
                },
                {
                    "_id": "S7K001",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab346",
                    "sku": "S7K001",
                    "category_sku": "Brushes",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Eye Brushes",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A7834",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab25a",
                    "sku": "3A7834",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "B38K01",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674ab392",
                    "sku": "B38K01",
                    "category_sku": "Styling / Primer Prep",
                    "abcd": "C",
                    "marca": "Bumble",
                    "plc_local": "4-Launch Event",
                    "sub_categoria_sku": "Curl / Wave Enhancing",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E6402",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674ab0d6",
                    "sku": "3E6402",
                    "category_sku": "Lip Treatment",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Lip Treatment",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL221",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2ca",
                    "sku": "SKL221",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL204",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab00e",
                    "sku": "SKL204",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CTY04",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacce",
                    "sku": "3CTY04",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaeee",
                    "sku": "SMXF01",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A2Y06",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab146",
                    "sku": "3A2Y06",
                    "category_sku": "Concealers & Correctors",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Concealers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SNWR72",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae06",
                    "sku": "SNWR72",
                    "category_sku": "Highlighter",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Highlighter",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMMMY1",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaeda",
                    "sku": "SMMMY1",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "3A2Y04",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab13a",
                    "sku": "3A2Y04",
                    "category_sku": "Concealers & Correctors",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Concealers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SN9T51",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae6e",
                    "sku": "SN9T51",
                    "category_sku": "Eye Liners",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMJ001",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab09a",
                    "sku": "SMJ001",
                    "category_sku": "Accessories",
                    "abcd": "C",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Lash / Adhesives",
                    "hero": "non-hero"
                },
                {
                    "_id": "43A332",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad6e",
                    "sku": "43A332",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Creme de La Mer",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "S39001",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab16a",
                    "sku": "S39001",
                    "category_sku": "Applicators",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Eye Applicators",
                    "hero": "non-hero"
                },
                {
                    "_id": "SHPH10",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aabea",
                    "sku": "SHPH10",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "AYPH01",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674ab1b6",
                    "sku": "AYPH01",
                    "category_sku": "All Other Other Haircare",
                    "abcd": "",
                    "marca": "Aveda",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKH0Y0",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aaf82",
                    "sku": "SKH0Y0",
                    "category_sku": "Toners / Clarifyers",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Toners / Clarifyers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMCCLE",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacaa",
                    "sku": "SMCCLE",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "S77813",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad22",
                    "sku": "S77813",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CFT04",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab1da",
                    "sku": "3CFT04",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Gel Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "C6GW01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad02",
                    "sku": "C6GW01",
                    "category_sku": "Makeup Primers/Finisher/F",
                    "abcd": "",
                    "marca": "Smashbox",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Makeup Primers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2ba",
                    "sku": "SL7C01",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E4608",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab01a",
                    "sku": "3E4608",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "3AYK01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab28a",
                    "sku": "3AYK01",
                    "category_sku": "Accessories",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Accessories",
                    "hero": "non-hero"
                },
                {
                    "_id": "43A323",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad62",
                    "sku": "43A323",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Creme de La Mer",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJC221",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab03e",
                    "sku": "SJC221",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "C6H511",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac12",
                    "sku": "C6H511",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "Smashbox",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK3T01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad9a",
                    "sku": "SK3T01",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "39T401",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab062",
                    "sku": "39T401",
                    "category_sku": "Accessories",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Accessories",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJC219",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae7e",
                    "sku": "SJC219",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "3C7Y03",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab236",
                    "sku": "3C7Y03",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF13",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf1a",
                    "sku": "SMXF13",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL222",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2da",
                    "sku": "SKL222",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "V16H11",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf3a",
                    "sku": "V16H11",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Clinique",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "39MK33",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0c2",
                    "sku": "39MK33",
                    "category_sku": "Concealers & Correctors",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Concealers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKKG06",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaff2",
                    "sku": "SKKG06",
                    "category_sku": "Lip Liner",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Liner",
                    "hero": "non-hero"
                },
                {
                    "_id": "C6H506",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacde",
                    "sku": "C6H506",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "Smashbox",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Eyeshadows",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E0A01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab02e",
                    "sku": "3E0A01",
                    "category_sku": "Cross Application Sets",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Application Set",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK3702",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab342",
                    "sku": "SK3702",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Single",
                    "hero": "non-hero"
                },
                {
                    "_id": "SHPH15",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac0a",
                    "sku": "SHPH15",
                    "category_sku": "Eyebrow Liners / Shapers",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Eyebrow Liners / Shap",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL217",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2b6",
                    "sku": "SKL217",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJC220",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab02a",
                    "sku": "SJC220",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK3R01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad92",
                    "sku": "SK3R01",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "3E5E01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aabda",
                    "sku": "3E5E01",
                    "category_sku": "Lip Gloss",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF16",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae82",
                    "sku": "SMXF16",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "S4K045",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab172",
                    "sku": "S4K045",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF20",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae92",
                    "sku": "SMXF20",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMXF22",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aae9a",
                    "sku": "SMXF22",
                    "category_sku": "Lipsticks",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "V29LY1",
                    "categoria_principal_sku": "Skincare",
                    "id": "60cce1a0b4f9c4d0674aaf6e",
                    "sku": "V29LY1",
                    "category_sku": "Cross Category Sets",
                    "abcd": "",
                    "marca": "Clinique",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Category Sets",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK3N01",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab352",
                    "sku": "SK3N01",
                    "category_sku": "Brushes",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Other Brushes",
                    "hero": "non-hero"
                },
                {
                    "_id": "B38G01",
                    "categoria_principal_sku": "Haircare",
                    "id": "60cce1a0b4f9c4d0674ab38a",
                    "sku": "B38G01",
                    "category_sku": "Styling / Primer Prep",
                    "abcd": "B",
                    "marca": "Bumble",
                    "plc_local": "4-Launch Event",
                    "sub_categoria_sku": "Curl / Wave Enhancing",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK6P19",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aac2a",
                    "sku": "SK6P19",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKKF7K",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aafee",
                    "sku": "SKKF7K",
                    "category_sku": "Lip Gloss",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "V16H02",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf56",
                    "sku": "V16H02",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Clinique",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "SJC211",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacc2",
                    "sku": "SJC211",
                    "category_sku": "Liquid Lip",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Liquid Lip",
                    "hero": "non-hero"
                },
                {
                    "_id": "V16H07",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aaf46",
                    "sku": "V16H07",
                    "category_sku": "Eye Liners",
                    "abcd": "",
                    "marca": "Clinique",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pencil Eye Liners",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKL237",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab36e",
                    "sku": "SKL237",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Cream Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C56",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab166",
                    "sku": "SL7C56",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                },
                {
                    "_id": "SKEC02",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aad0a",
                    "sku": "SKEC02",
                    "category_sku": "Lip Gloss",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lip Gloss",
                    "hero": "non-hero"
                },
                {
                    "_id": "3CJ801",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab2a2",
                    "sku": "3CJ801",
                    "category_sku": "Cross Application Sets",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Cross Application Set",
                    "hero": "non-hero"
                },
                {
                    "_id": "SK3722",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab366",
                    "sku": "SK3722",
                    "category_sku": "Eyeshadow",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Single",
                    "hero": "non-hero"
                },
                {
                    "_id": "SMCH57",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674aacb6",
                    "sku": "SMCH57",
                    "category_sku": "Face Powder",
                    "abcd": "D",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Pressed Face Powder",
                    "hero": "non-hero"
                },
                {
                    "_id": "SLY8Y0",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab162",
                    "sku": "SLY8Y0",
                    "category_sku": "Lipsticks",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "All Lipsticks",
                    "hero": "non-hero"
                },
                {
                    "_id": "39MK31",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab0ca",
                    "sku": "39MK31",
                    "category_sku": "Concealers & Correctors",
                    "abcd": "",
                    "marca": "Too Faced",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Concealers",
                    "hero": "non-hero"
                },
                {
                    "_id": "SL7C36",
                    "categoria_principal_sku": "Makeup",
                    "id": "60cce1a0b4f9c4d0674ab1ae",
                    "sku": "SL7C36",
                    "category_sku": "Foundation",
                    "abcd": "",
                    "marca": "MAC",
                    "plc_local": "3-Released",
                    "sub_categoria_sku": "Liquid Foundation",
                    "hero": "non-hero"
                }
            ];


        return (
            <React.Fragment>
                <Layout>
                    <Grid class="painel" fullWidth>
                        <div className="header-text header-text-report">
                            <h5>{leng.sideBar.intelligentJourney.title}</h5>
                            <h3>{leng.sideBar.intelligentJourney.links[3]}</h3>
                        </div>
                        <div>
                            <CreateFilters data={data} isLoading={isLoading} onChange={(e) => {
                                this.handleChange(e)
                            }}/>
                        </div>
                    </Grid>
                </Layout>
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({schedule}) => schedule;

const mapDispatchToProps = dispatch => ({
    fetchData: () => dispatch(schedule_get_all_filters()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Create);
